<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" [formGroup]="formGroup">
  <div class="form-group col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
    <label for="{{bNControlId}}" class="control-label" *ngIf="showLabel">
      <span *ngIf="!labelBN" i18n="@@animalBreedingNumber">Breeding number</span>
      <span *ngIf="labelBN">{{labelBN}}</span>&nbsp;<span *ngIf="showRequired && bNRequired">*</span>
    </label>

    <input id="{{bNControlId}}" type="text" class="form-control text-uppercase"
           [formControlName]="bNControlName" [readOnly]="readonly" [class.is-invalid]="bNShowInvalid"
           [class.is-valid]="bNShowValid" (keypress)="keypress($event)" (change)="onChange($event)">

    <div *ngIf="bNShowInvalid" class="invalid-feedback">
      <div *ngIf="bNControl?.hasError('required')" i18n="@@requiredInput">This input is required.</div>

      <div *ngIf="bNControl?.hasError('pattern')" i18n="@@animalBreedingNumberPattern">
        {{animalDetail?.breedingNumberRegexMessage}}
      </div>
    </div>
  </div>

  <div class="form-group col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 text-center">
    <label for="splitDelimiterID">&nbsp;</label>
    <strong id="splitDelimiterID">{{splitDelimiter}}</strong>
  </div>

  <div class="form-group col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5">
    <label for="{{bOControlId}}" class="control-label" *ngIf="showLabel">
      <span *ngIf="!labelBO" i18n="@@animalBreedingOrder">Breeding order</span>
      <span *ngIf="labelBO">{{labelBO}}</span>&nbsp;<span *ngIf="showRequired && bORequired">*</span>
    </label>

    <input id="{{bOControlId}}" type="text" class="form-control text-uppercase"
           [formControlName]="bOControlName" [readOnly]="readonly" [class.is-invalid]="bOShowInvalid"
           [class.is-valid]="bOShowValid" (keypress)="keypress($event)" (change)="onChange($event)">

    <div *ngIf="bOShowInvalid" class="invalid-feedback">
      <div *ngIf="bOControl?.hasError('required')" i18n="@@requiredInput">This input is required.</div>

      <div *ngIf="bOControl?.hasError('pattern')" i18n="@@animalBreedingOrderPattern">
        {{animalDetail?.breedingOrderRegexMessage}}
      </div>
    </div>
  </div>
</div>
